export const publicRuntimeConfig = {
  customValuePublic: 'value',
};

export const privateRuntimeConfig = {
  customValuePrivate: true,
};
